<template>
  <div class="info">
    <div class="infoTop">
      <img :src="teacher.head" alt class="avatar" />
      <span class="userName">
        你好，{{ teacher.name }}老师({{ teacher.kinderGartenName }})
      </span>
      <span class="bm-js">
        {{ teacher.sys_DepartmentName }} - {{ teacher.sys_RoleName }}
      </span>
      <!-- <span class="userName"></span> -->
    </div>
    <div class="infochild">
      <ul>
        <li class="account">
          <router-link to="/account">
            <i class="icon"></i>
            <p>帐号信息</p>
          </router-link>
        </li>
        <li class="schoolNews">
          <router-link to="/schoolNews">
            <i class="icon"></i>
            <p>学校公告</p>
            <span class="count" v-if="xxCount > 0">{{ xxCount }}</span>
          </router-link>
        </li>
        <li class="classNews">
          <router-link to="/classNews">
            <i class="icon"></i>
            <p>班级消息</p>
            <span class="count" v-if="bjCount > 0">{{ bjCount }}</span>
          </router-link>
        </li>
        <li class="quit">
          <a href="javascript:;" @click="logout()">
            <i class="icon"></i>
            <p>退出登录</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {
    logout() {
      this.$confirm("你确定要登出吗?", "提示", {
        // confirmButtonText: "确定",
        // cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .get("api/user/TeacherLogout")
            .then((res) => {
              if (res.data.resultType == 0) {
                this.$message.success("登出成功!");
                // this.$store.commit("setUser", {});
                // this.$store.commit("setClass", []);
                var validation = localStorage.getItem("Validation");
                localStorage.clear();
                localStorage.setItem("Validation", validation);
                this.$router.push("/login");
              } else {
                this.$alert(res.data.message, "提示");
              }
            })
            .catch((err) => {
              this.$alert(err);
            });
        })
        .catch(() => {
          this.$message.info("已取消登出");
        });
    },
  },
  props: ["xxCount", "bjCount", "teacher"],
};
</script>

<style scoped lang="less">
.info {
  background: #f5f6f9;
  width: 370px;
  border-radius: 8px;
  position: absolute;
  top: 68px;
  // left: -130px;
  left: -250px;
  border: 1px solid #e5e5e5;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  z-index: 99;

  &:before {
    content: "";
    width: 100%;
    height: 8px;
    background: url(../../assets/images/img_sj.png) no-repeat;
    background-size: 15px 8px;
    background-position: center 0;
    position: absolute;
    top: -8px;
    // left: -30px;
    left: 90px;
  }

  .infoTop {
    width: 370px;
    height: 85px;
    background: #fff;
    border-radius: 8px 8px 0 0;
    padding: 0 20px;
    display: table-cell;
    vertical-align: middle;

    .avatar {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      display: inline-block;
      vertical-align: middle;
    }

    .userName {
      display: inline-block;
      vertical-align: middle;
      font-size: 15px;
      color: #505f75;
      margin-left: 5px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 270px;
    }
    .bm-js {
      background: url("../../assets/img/yh_xtb_bm.png") no-repeat;
      background-size: 18px;
      text-indent: 20px;
      color: #6abe3c;
      font-size: 14px;
      display: block;
      margin-left: 52px;
    }
  }

  .infochild {
    background: #f5f6f9;

    > ul {
      li {
        position: relative;
        font-size: 14px;
        padding: 12px 0;
        float: left;
        width: 25%;
        text-align: center;

        .icon {
          display: inline-block;
          width: 22px;
          height: 22px;
        }

        p {
          color: #666666;
        }

        .count {
          display: inline-block;
          min-width: 21px;
          height: 16px;
          border-radius: 10px;
          background: #ff0e0e;
          color: #fff;
          font-size: 12px;
          text-align: center;
          line-height: 16px;
          position: absolute;
          left: 62px;
          top: 8px;
        }
      }

      .account i {
        background: url("../../assets/images/img_settings_icon1.png") no-repeat;
        background-size: 21px 18px;
        background-position: center center;
      }

      .schoolNews i {
        background: url("../../assets/images/img_settings_icon2.png") no-repeat;
        background-size: 18px 18px;
        background-position: center center;
      }

      .classNews i {
        background: url("../../assets/images/img_settings_icon3.png") no-repeat;
        background-size: 19px 18px;
        background-position: center center;
      }

      .quit i {
        background: url("../../assets/images/img_settings_icon4.png") no-repeat;
        background-size: 18px 15px;
        background-position: center center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/TeacherDropdown.vue